/** Accesso al modulo Immobiliare — abilitato dal super-admin per utente. */
export function canAccessImmobiliare(user) {
  if (!user) return false;
  return Boolean(user.immobiliare_enabled);
}
